import { render, staticRenderFns } from "./IrrigationArea.vue?vue&type=template&id=3cfefc84&scoped=true"
import script from "./IrrigationArea.vue?vue&type=script&lang=js"
export * from "./IrrigationArea.vue?vue&type=script&lang=js"
import style0 from "./IrrigationArea.vue?vue&type=style&index=0&id=3cfefc84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfefc84",
  null
  
)

export default component.exports